import toastr from 'toastr';

function defaultToast(
	text = '',
	type = 'success',
	position = 'toast-top-right',
	redirect = '',
	useProgressBar = false
) {
	const submitButton = document.getElementById('submit-btn-amendment') as HTMLButtonElement | null;
	const draftButton = document.getElementById('draft-btn-amendment') as HTMLButtonElement | null;
	if (submitButton && draftButton) {
		submitButton.disabled = true;
		draftButton.disabled = true;
	}

	toastr.options = {
		closeButton: false,
		debug: false,
		newestOnTop: false,
		progressBar: useProgressBar,
		positionClass: position,
		preventDuplicates: false,
		showDuration: 300,
		hideDuration: 1000,
		timeOut: 5000,
		extendedTimeOut: 1000,
		showEasing: 'swing',
		hideEasing: 'linear',
		showMethod: 'fadeIn',
		hideMethod: 'fadeOut',
		onHidden: function () {
			if (redirect) {
				window.location.href = redirect;
			} else {
				if (submitButton && draftButton) {
					submitButton.disabled = false;
					draftButton.disabled = false;
				}
			}
		},
	};

	// Show toast based on type
	if (type === 'error') {
		toastr.error(text);
	} else if (type === 'warning') {
		toastr.warning(text);
	} else {
		toastr.success(text);
	}

	if (redirect) {
		window.addEventListener('load', () => {
			if (submitButton && draftButton) {
				submitButton.disabled = true;
				draftButton.disabled = true;
			}
		});
	}
}

export default defaultToast;